// src/Tuning/WhyChooseUs/WhyChooseUsList/WhyChooseUsList.jsx
import React from 'react';
import WhyChooseUsTable from './Components/WhyChooseUsTable';
import AddItemBtn from 'Common/Custom/AddItemBtn';
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const WhyChooseUsList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <> 
          <HeadingOne>Why Choose Us List</HeadingOne>
          <AddItemBtn url="whychooseus-add" title="Create Entry" />
        </>
      }
    >
      {/* Table section */}
      <div className="col-12">
        <WhyChooseUsTable />
      </div>
    </PageBody>
  );
};

export default WhyChooseUsList;
